module.exports = __webpack_public_path__ + "img/anonymous.2a0c2352.svg";